import { render } from "./StoreItem.vue?vue&type=template&id=4d896d91&scoped=true&ts=true"
import script from "./StoreItem.vue?vue&type=script&lang=ts"
export * from "./StoreItem.vue?vue&type=script&lang=ts"

import "./StoreItem.scss?vue&type=style&index=0&id=4d896d91&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d896d91"]])

export default __exports__